var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSale = function SvgSale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCAA1",
    d: "M35.283 24.677H6.718v13.871h28.565z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6E3037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M1 41h40M9.98 11.528H6.715v3.265H9.98zM17.326 11.528h-3.265v3.265h3.265zM2.633 41V22.319M39.368 22.319V41M41 18.96H1v3.264h40zM23.04 6.715V9.96l-1.632-.773-.22-.104-3.253-1.713-2.982-1.472-3.042-1.603-3.034 1.603-6.056 3.2-.188.088L1 9.96V6.715L12.005 1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6E3037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M21.408 9.187v9.772H2.633V9.186M21.408 13.245H41M24.673 18.96v-5.715M27.939 18.96v-5.715M31.204 18.96v-5.715M34.47 18.96v-5.715M37.735 18.96v-5.715M41 18.96v-5.715M15.7 34.95l2.714-6.49c.055-.123.247-.123.303 0l2.69 6.49M16.546 33.334h4.029M24.67 28.368v6.578c.072.012 3.262 0 3.262 0M12.417 29.045s-1.181-.993-2.574-.573c-1.279.385-1.458 1.86-.532 2.463 0 0 .908.405 1.915.776 2.424.895 1.38 3.24-.572 3.24-.977 0-1.797-.427-2.294-.975M33.64 28.427h-2.447v6.494h2.447M33.44 31.632h-2.246"
  })));
};
export default SvgSale;